import categorys from 'utils/categorys.js'
var data = {};
data.ServiceDate = [{
    ServiceName: '国内机票服务',
    ServiceCode: 'flight',
    ServiceType:categorys.types.ServiceType.FlightService,
    ApplyArea: categorys.types.ApplyArea.Internal,
    ServiceID: 'S00000000009',
},{
    ServiceName: '国际机票服务',
    ServiceCode: 'flight',
    ServiceType:categorys.types.ServiceType.FlightService,
    ApplyArea: categorys.types.ApplyArea.Overseas,
    ServiceID: 'S00000000011',
},{
    ServiceName: '国内酒店服务',
    ServiceCode: 'hotel',
    ServiceType:categorys.types.ServiceType.HotelService,
    ApplyArea: categorys.types.ApplyArea.Internal,
    ServiceID: 'S00000000013',
},{
    ServiceName: '国际酒店服务',
    ServiceCode: 'hotel',
    ServiceType:categorys.types.ServiceType.HotelService,
    ApplyArea: categorys.types.ApplyArea.Overseas,
    ServiceID: 'S00000000015',
},{
    ServiceName: '国内旅游服务',
    ServiceCode: 'tour',
    ServiceType:categorys.types.ServiceType.TourService,
    ApplyArea: categorys.types.ApplyArea.Internal,
    ServiceID: 'S00000000005',
},{
    ServiceName: '国际旅游服务',
    ServiceCode: 'tour',
    ServiceType:categorys.types.ServiceType.TourService,
    ApplyArea: categorys.types.ApplyArea.Overseas,
    ServiceID: 'S00000000007',
},{
    ServiceName: '国内火车票服务',
    ServiceCode: 'train',
    ServiceType:categorys.types.ServiceType.TrainService,
    ApplyArea: categorys.types.ApplyArea.Internal,
    ServiceID: 'S00000000017',
},{
    ServiceName: '保险服务',
    ServiceCode: 'insurance',
    ServiceType:categorys.types.ServiceType.InsuranceService,
    ApplyArea: categorys.types.ApplyArea.Internal,
    ServiceID: 'S00000000025',
},{
    ServiceName: '增值服务',
    ServiceCode: 'charge',
    ServiceType:categorys.types.ServiceType.ChargeService,
    ApplyArea: categorys.types.ApplyArea.Internal,
    ServiceID: 'S00000000043',
},{
    ServiceName: '用车服务',
    ServiceCode: 'traffic',
    ServiceType:categorys.types.ServiceType.TrafficService,
    ApplyArea: categorys.types.ApplyArea.Internal,
    ServiceID: 'S00000000029',
}];
data.service = function (ServiceType, ApplyArea) {
    let ServiceID = "";
    // let applyarea = categorys.types.ApplyArea;
    // let servicetype = categorys.types.ServiceType;
    // if (ServiceType == "flight" && ApplyArea == applyarea.Internal) {
    //     ServiceID = "S00000000009"; //国内机票
    // } else if (ServiceType == "flight" && ApplyArea == applyarea.Overseas) {
    //     ServiceID = "S00000000011"; //国际机票
    // } else if (ServiceType == "hotel" && ApplyArea == applyarea.Internal) {
    //     ServiceID = "S00000000013"; //国内酒店
    // } else if (ServiceType == "hotel" && ApplyArea == applyarea.Overseas) {
    //     ServiceID = "S00000000015"; //国际酒店
    // } else if (ServiceType == "tour" && ApplyArea == applyarea.Internal) {
    //     ServiceID = "S00000000005"; //国内旅游
    // } else if (ServiceType == "tour" && ApplyArea == applyarea.Overseas) {
    //     ServiceID = "S00000000007"; //国际旅游
    // } else {
    //     ServiceID = "S00000000017"; //国内火车票
    // }
    for (let s = 0; s < data.ServiceDate.length; s++) {
        const element = data.ServiceDate[s];
        if((ServiceType==element.ServiceCode&&ApplyArea==element.ApplyArea)||(ServiceType==element.ServiceType&&ApplyArea==element.ApplyArea)){
            ServiceID=element.ServiceID;
            break;
        }
    }
    return ServiceID;
}
export default data;



// WEBPACK FOOTER //
// ./src/views/manage/order/service.js